// import React from 'react'

// const RewardsPolicy = () => {

//     const MembershipPolicy = () => {
//         const tiers = [
//             {
//                 name: 'Silver',
//                 monthlySpend: '1 – 10,000',
//                 color: '🥈 Silver',
//                 rewardPoints: '1,000 Points',
//                 creditPeriod: 'Up to 30 Days',
//                 welcomePoints: '500 Points',
//             },
//             {
//                 name: 'Gold',
//                 monthlySpend: '10,001 – 29,999',
//                 color: '🥇 Gold',
//                 rewardPoints: '1,500 Points',
//                 creditPeriod: 'Up to 45 Days',
//                 welcomePoints: '1,000 Points',
//                 loyaltyBonus: '5,000 Points',
//                 annualGift: 'Surprise Annual Gift',
//             },
//             {
//                 name: 'Platinum',
//                 monthlySpend: '30,000+',
//                 color: '💎 Platinum',
//                 rewardPoints: '2,000 Points',
//                 creditPeriod: 'Up to 60 Days',
//                 welcomePoints: '3,000 Points',
//                 loyaltyBonus: '10,000 Points',
//                 annualGift: 'Surprise Annual Gift',
//             },
//         ];

//         return (
//             <div className="container mx-auto p-4">
//                 <h2 className='text-center'>🌟 Customer Membership & Reward Policy 🌟</h2>

//                 {/* Membership Tiers */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }}>1. Membership Tiers (Monthly Spend Basis)</h3>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Monthly Spend (AED)</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.monthlySpend}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Reward Points */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">2. Reward Points (Per AED 10,000 Spent)</h3>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Reward Points</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.rewardPoints}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Credit Facility */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">3. Credit Facility</h3>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Credit Period</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.creditPeriod}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Welcoming Points */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">4. Welcoming Points (One-Time on Joining)</h3>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Welcoming Points</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.welcomePoints}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Redemption Policy */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">5. Redemption Policy</h3>
//                     <ul className="list-disc">
//                         <li>Points can be redeemed anytime after a member’s total first-time purchases reach AED 5,000, which may include multiple invoices.</li>
//                         <li>Redemption is available via the listed products/gifts catalog.</li>
//                     </ul>
//                 </div>

//                 {/* Downgrade Policy */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">6. Downgrade Policy</h3>
//                     <p>If any member (Gold, or Platinum) fails to meet their monthly target for two consecutive months, they will be automatically downgraded to the lower tier in the third month without prior notice.</p>
//                 </div>

//                 {/* Loyalty Milestone Bonus */}
//                 <div className='mb-2'>
//                     <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">7. Loyalty Milestone Bonus</h3>
//                     <p>Gold & Platinum members only: Members who consistently achieve their monthly target for 6 consecutive months will receive:</p>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Bonus Points</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.slice(1).map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.loyaltyBonus}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                     <p className="mt-4">Annual / 9-Month Milestone: Members who consistently achieve their monthly target for 12 consecutive months or 9 months will receive:</p>
//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr className="bg-gray-100">
//                                     <th className="border p-2">Tier</th>
//                                     <th className="border p-2">Special Gift</th>
//                                     <th className="border p-2">Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.slice(1).map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2">{tier.name}</td>
//                                         <td className="border p-2">{tier.annualGift}</td>
//                                         <td className="border p-2">{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* General Conditions */}
//                 <div className='mb-2'>
//                     {/* <h3 style={{ fontWeight: "semibold" }} className="text-2xl font-semibold">8. General Conditions</h3> */}
//                     <p>
//                         <strong style={{ fontWeight: "bolder" }}>
//                             8. General Conditions
//                         </strong>
//                     </p>
//                     <ul className="list-disc">
//                         <li style={{ color: "rgb(127, 127, 127)" }}>Points are valid for 12 months from the date of earning.</li>
//                         <li style={{ color: "rgb(127, 127, 127)" }}>Points are non-transferable and cannot be exchanged for cash.</li>
//                         <li style={{ color: "rgb(127, 127, 127)" }}>The redemption catalog may be updated at any time without prior notice.</li>
//                     </ul>
//                 </div>
//             </div>
//         );
//     };

//     return <MembershipPolicy />
// }

// export default RewardsPolicy;



// import React from 'react';

// const RewardsPolicy = () => {
//     const MembershipPolicy = () => {
//         const tiers = [
//             {
//                 name: 'Silver',
//                 monthlySpend: '1 – 10,000',
//                 color: '🥈 Silver',
//                 rewardPoints: '1,000 Points',
//                 creditPeriod: 'Up to 30 Days',
//                 welcomePoints: '500 Points',
//             },
//             {
//                 name: 'Gold',
//                 monthlySpend: '10,001 – 29,999',
//                 color: '🥇 Gold',
//                 rewardPoints: '1,500 Points',
//                 creditPeriod: 'Up to 45 Days',
//                 welcomePoints: '1,000 Points',
//                 loyaltyBonus: '5,000 Points',
//                 annualGift: 'Surprise Annual Gift',
//             },
//             {
//                 name: 'Platinum',
//                 monthlySpend: '30,000+',
//                 color: '💎 Platinum',
//                 rewardPoints: '2,000 Points',
//                 creditPeriod: 'Up to 60 Days',
//                 welcomePoints: '3,000 Points',
//                 loyaltyBonus: '10,000 Points',
//                 annualGift: 'Surprise Annual Gift',
//             },
//         ];

//         const styles = {
//             mainTitle: {
//                 fontWeight: 700,
//                 color: '#1f2937',
//                 textAlign: 'center',
//             },
//             sectionTitle: {
//                 fontSize: '16px',
//                 fontWeight: 700,
//                 color: '#000',
//                 marginBottom: '15px',
//             },
//             text: {
//                 fontSize: '15px',
//                 fontWeight: 400,
//                 color: '#6b7280',
//                 lineHeight: '1.7',
//             },
//             listItem: {
//                 fontSize: '15px',
//                 fontWeight: 400,
//                 color: '#6b7280',
//                 marginBottom: '3px',
//             },
//             tableHeader: {
//                 fontSize: '15px',
//                 fontWeight: 700,
//                 color: '#000',
//             },
//             tableCell: {
//                 fontSize: '15px',
//                 fontWeight: 400,
//                 color: '#6b7280',
//             },
//         };

//         return (
//             <div className="container mx-auto p-4">
//                 <h2 style={styles.mainTitle}>
//                     🌟 Customer Membership & Reward Policy 🌟
//                 </h2>

//                 {/* Membership Tiers */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>
//                         1. Membership Tiers (Monthly Spend Basis)
//                     </h3>

//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr>
//                                     <th className="border p-2" style={styles.tableHeader}>Tier</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Monthly Spend (AED)</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.name}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.monthlySpend}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Reward Points */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>
//                         2. Reward Points (Per AED 10,000 Spent)
//                     </h3>

//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr>
//                                     <th className="border p-2" style={styles.tableHeader}>Tier</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Reward Points</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.name}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.rewardPoints}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Credit Facility */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>3. Credit Facility</h3>

//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr>
//                                     <th className="border p-2" style={styles.tableHeader}>Tier</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Credit Period</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.name}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.creditPeriod}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Welcoming Points */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>
//                         4. Welcoming Points (One-Time on Joining)
//                     </h3>

//                     <div className="overflow-x-auto">
//                         <table className="w-full border-collapse border">
//                             <thead>
//                                 <tr>
//                                     <th className="border p-2" style={styles.tableHeader}>Tier</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Welcoming Points</th>
//                                     <th className="border p-2" style={styles.tableHeader}>Color</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {tiers.map((tier) => (
//                                     <tr key={tier.name}>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.name}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.welcomePoints}</td>
//                                         <td className="border p-2" style={styles.tableCell}>{tier.color}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//                 {/* Redemption Policy */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>5. Redemption Policy</h3>

//                     <ul className="ps-4">
//                         <li style={styles.listItem}>
//                             Points can be redeemed anytime after a member’s total first-time purchases reach AED 5,000.
//                         </li>
//                         <li style={styles.listItem}>
//                             Redemption is available via the listed products/gifts catalog.
//                         </li>
//                     </ul>
//                 </div>

//                 {/* Downgrade Policy */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>6. Downgrade Policy</h3>

//                     <p style={styles.text}>
//                         If any member (Gold or Platinum) fails to meet their monthly target
//                         for two consecutive months, they will be automatically downgraded
//                         to the lower tier in the third month without prior notice.
//                     </p>
//                 </div>

//                 {/* Loyalty Bonus */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>7. Loyalty Milestone Bonus</h3>

//                     <p style={styles.text}>
//                         Gold & Platinum members only: Members who consistently achieve
//                         their monthly target for 6 consecutive months will receive:
//                     </p>
//                 </div>

//                 {/* General Conditions */}
//                 <div className="mb-5">
//                     <h3 style={styles.sectionTitle}>8. General Conditions</h3>

//                     <ul className="ps-4">
//                         <li style={styles.listItem}>
//                             Points are valid for 12 months from the date of earning.
//                         </li>
//                         <li style={styles.listItem}>
//                             Points are non-transferable and cannot be exchanged for cash.
//                         </li>
//                         <li style={styles.listItem}>
//                             The redemption catalog may be updated at any time without prior notice.
//                         </li>
//                     </ul>
//                 </div>
//             </div>
//         );
//     };

//     return <MembershipPolicy />;
// };

// export default RewardsPolicy;

// import React from "react";
// import "./RewardsPolicy.css";

// const RewardsPolicy = () => {
//     const tiers = [
//         {
//             name: "Silver",
//             icon: "🥈",
//             monthlySpend: "1 – 10,000 AED ",
//             rewardPoints: "1,000 Points",
//             creditPeriod: "Up to 30 Days",
//             welcomePoints: "500 Points",
//             loyaltyBonus: "-",
//             annualGift: "-",
//             className: "silver",
//         },
//         {
//             name: "Gold",
//             icon: "🥇",
//             monthlySpend: "10,001 – 29,999 AED ",
//             rewardPoints: "1,500 Points",
//             creditPeriod: "Up to 45 Days",
//             welcomePoints: "1,000 Points",
//             loyaltyBonus: "5,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "gold",
//         },
//         {
//             name: "Platinum",
//             icon: "💎",
//             monthlySpend: "30,000 AED ",
//             rewardPoints: "2,000 Points",
//             creditPeriod: "Up to 60 Days",
//             welcomePoints: "3,000 Points",
//             loyaltyBonus: "10,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "platinum",
//         },
//     ];

//     return (
//         <div className="rewards-page">
//             <div className="rewards-hero">
//                 <span className="hero-badge">Rewards Program</span>
//                 <h1>Customer Membership & Reward Policy</h1>
//                 <p>
//                     Earn reward points, enjoy credit facilities, and unlock milestone
//                     bonuses based on your monthly purchase value.
//                 </p>
//             </div>

//             <div className="tier-grid">
//                 {tiers.map((tier) => (
//                     <div className={`tier-card ${tier.className}`} key={tier.name}>
//                         <div className="tier-top">
//                             <div className="tier-icon">{tier.icon}</div>
//                             <h2>{tier.name}</h2>
//                             <p>{tier.monthlySpend}</p>
//                         </div>

//                         <div className="tier-info">
//                             <div>
//                                 <span>Reward Points</span>
//                                 <strong>{tier.rewardPoints}</strong>
//                             </div>
//                             <div>
//                                 <span>Credit Period</span>
//                                 <strong>{tier.creditPeriod}</strong>
//                             </div>
//                             <div>
//                                 <span>Welcome Points</span>
//                                 <strong>{tier.welcomePoints}</strong>
//                             </div>
//                             <div>
//                                 <span>Loyalty Bonus</span>
//                                 <strong>{tier.loyaltyBonus}</strong>
//                             </div>
//                             <div>
//                                 <span>Annual Gift</span>
//                                 <strong>{tier.annualGift}</strong>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className="policy-grid">
//                 <div className="policy-card">
//                     <h3>Redemption Policy</h3>
//                     <ul>
//                         <li>
//                             Points can be redeemed after first-time total purchases reach AED
//                             5,000.
//                         </li>
//                         <li>Redemption is available through the listed gifts catalog.</li>
//                     </ul>
//                 </div>

//                 <div className="policy-card">
//                     <h3>Downgrade Policy</h3>
//                     <p>
//                         Gold or Platinum members who fail to meet their monthly target for
//                         two consecutive months will be downgraded in the third month.
//                     </p>
//                 </div>

//                 <div className="policy-card">
//                     <h3>Loyalty Milestone Bonus</h3>
//                     <p>
//                         Gold and Platinum members who achieve their monthly target for 6
//                         consecutive months receive bonus points.
//                     </p>
//                 </div>

//                 <div className="policy-card">
//                     <h3>General Conditions</h3>
//                     <ul>
//                         <li>Points are valid for 12 months.</li>
//                         <li>Points are non-transferable.</li>
//                         <li>Points cannot be exchanged for cash.</li>
//                     </ul>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RewardsPolicy;


// import React from "react";
// import {
//     FaMedal,
//     FaCrown,
//     FaGem,
//     FaGift,
//     FaCoins,
//     FaCreditCard,
//     FaShieldAlt
// } from "react-icons/fa";

// import "./RewardsPolicy.css";

// const RewardsPolicy = () => {

//     const tiers = [
//         {
//             name: "Silver",
//             icon: <FaMedal />,
//             monthlySpend: "1 – 10,000 AED",
//             rewardPoints: "1,000 Points",
//             creditPeriod: "Up to 30 Days",
//             welcomePoints: "500 Points",
//             loyaltyBonus: "-",
//             annualGift: "-",
//             className: "silver",
//         },
//         {
//             name: "Gold",
//             icon: <FaCrown />,
//             monthlySpend: "10,001 – 29,999 AED",
//             rewardPoints: "1,500 Points",
//             creditPeriod: "Up to 45 Days",
//             welcomePoints: "1,000 Points",
//             loyaltyBonus: "5,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "gold",
//         },
//         {
//             name: "Platinum",
//             icon: <FaGem />,
//             monthlySpend: "30,000+ AED",
//             rewardPoints: "2,000 Points",
//             creditPeriod: "Up to 60 Days",
//             welcomePoints: "3,000 Points",
//             loyaltyBonus: "10,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "platinum",
//         },
//     ];

//     return (
//         <div className="rewards-page">

//             {/* HERO */}
//             <div className="rewards-hero">

//                 <span className="hero-badge">
//                     Rewards Program
//                 </span>

//                 <h1>
//                     Customer Membership & Reward Policy
//                 </h1>

//                 <p>
//                     Earn reward points, enjoy credit facilities,
//                     and unlock milestone bonuses based on your
//                     monthly purchase value.
//                 </p>

//             </div>

//             {/* MEMBERSHIP CARDS */}
//             <div className="tier-grid">

//                 {tiers.map((tier) => (

//                     <div
//                         className={`tier-card ${tier.className}`}
//                         key={tier.name}
//                     >

//                         {/* CARD HEADER */}
//                         <div className="tier-top">

//                             <div className="tier-icon">
//                                 {tier.icon}
//                             </div>

//                             <h2>
//                                 {tier.name}
//                             </h2>

//                             <p>
//                                 {tier.monthlySpend}
//                             </p>

//                         </div>

//                         {/* CARD INFO */}
//                         <div className="tier-info">

//                             <div>
//                                 <span>
//                                     <FaCoins />
//                                     Reward Points
//                                 </span>

//                                 <strong>
//                                     {tier.rewardPoints}
//                                 </strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaCreditCard />
//                                     Credit Period
//                                 </span>

//                                 <strong>
//                                     {tier.creditPeriod}
//                                 </strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaGift />
//                                     Welcome Points
//                                 </span>

//                                 <strong>
//                                     {tier.welcomePoints}
//                                 </strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaShieldAlt />
//                                     Loyalty Bonus
//                                 </span>

//                                 <strong>
//                                     {tier.loyaltyBonus}
//                                 </strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaGift />
//                                     Annual Gift
//                                 </span>

//                                 <strong>
//                                     {tier.annualGift}
//                                 </strong>
//                             </div>

//                         </div>

//                     </div>
//                 ))}

//             </div>

//             {/* POLICY SECTION */}
//             <div className="policy-grid">

//                 <div className="policy-card">

//                     <h3>
//                         Redemption Policy
//                     </h3>

//                     <ul>
//                         <li>
//                             Points can be redeemed after first-time
//                             purchases reach AED 5,000.
//                         </li>

//                         <li>
//                             Redemption available through gifts catalog.
//                         </li>
//                     </ul>

//                 </div>

//                 <div className="policy-card">

//                     <h3>
//                         Downgrade Policy
//                     </h3>

//                     <p>
//                         Gold or Platinum members who fail to
//                         meet their target for 2 consecutive
//                         months will be downgraded.
//                     </p>

//                 </div>

//                 <div className="policy-card">

//                     <h3>
//                         Loyalty Milestone Bonus
//                     </h3>

//                     <p>
//                         Gold & Platinum members who achieve
//                         monthly targets for 6 consecutive months
//                         receive bonus points and special rewards.
//                     </p>

//                 </div>

//                 <div className="policy-card">

//                     <h3>
//                         General Conditions
//                     </h3>

//                     <ul>
//                         <li>
//                             Points are valid for 12 months.
//                         </li>

//                         <li>
//                             Points are non-transferable.
//                         </li>

//                         <li>
//                             Points cannot be exchanged for cash.
//                         </li>
//                     </ul>

//                 </div>

//             </div>

//         </div>
//     );
// };

// export default RewardsPolicy;



// import React from "react";
// import {
//     FaMedal,
//     FaCrown,
//     FaGem,
//     FaGift,
//     FaCoins,
//     FaCreditCard,
//     FaShieldAlt,
//     FaArrowDown,
//     FaAward,
// } from "react-icons/fa";

// import "./RewardsPolicy.css";

// const RewardsPolicy = () => {
//     const tiers = [
//         {
//             name: "Silver",
//             icon: <FaMedal />,
//             monthlySpend: "1 – 10,000 AED",
//             rewardPoints: "1,000 Points",
//             creditPeriod: "Up to 30 Days",
//             welcomePoints: "500 Points",
//             loyaltyBonus: "-",
//             annualGift: "-",
//             className: "silver",
//         },
//         {
//             name: "Gold",
//             icon: <FaCrown />,
//             monthlySpend: "10,001 – 29,999 AED",
//             rewardPoints: "1,500 Points",
//             creditPeriod: "Up to 45 Days",
//             welcomePoints: "1,000 Points",
//             loyaltyBonus: "5,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "gold",
//         },
//         {
//             name: "Platinum",
//             icon: <FaGem />,
//             monthlySpend: "30,000+ AED",
//             rewardPoints: "2,000 Points",
//             creditPeriod: "Up to 60 Days",
//             welcomePoints: "3,000 Points",
//             loyaltyBonus: "10,000 Points",
//             annualGift: "Surprise Annual Gift",
//             className: "platinum",
//         },
//     ];

//     return (
//         <div className="rewards-page">
//             <div className="rewards-hero">
//                 <h2>Rewards Program</h2>

//                 <h1>Customer Membership & Reward Policy</h1>

//                 <p>
//                     Earn reward points, enjoy credit facilities, and unlock milestone
//                     bonuses based on your monthly purchase value.
//                 </p>
//             </div>

//             <div className="tier-grid">
//                 {tiers.map((tier) => (
//                     <div className={`tier-card ${tier.className}`} key={tier.name}>
//                         <div className="tier-top">
//                             <div className="tier-icon">{tier.icon}</div>

//                             <h2>{tier.name}</h2>

//                             <p>{tier.monthlySpend}</p>
//                         </div>

//                         <div className="tier-info">
//                             <div>
//                                 <span>
//                                     <FaCoins />
//                                     Reward Points
//                                 </span>
//                                 <strong>{tier.rewardPoints}</strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaCreditCard />
//                                     Credit Period
//                                 </span>
//                                 <strong>{tier.creditPeriod}</strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaGift />
//                                     Welcome Points
//                                 </span>
//                                 <strong>{tier.welcomePoints}</strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaShieldAlt />
//                                     Loyalty Bonus
//                                 </span>
//                                 <strong>{tier.loyaltyBonus}</strong>
//                             </div>

//                             <div>
//                                 <span>
//                                     <FaGift />
//                                     Annual Gift
//                                 </span>
//                                 <strong>{tier.annualGift}</strong>
//                             </div>
//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className="policy-grid">
//                 <div className="policy-card">
//                     <div className="policy-icon">
//                         <FaGift />
//                     </div>

//                     <div className="policy-content">
//                         <h3>Redemption Policy</h3>
//                         <ul>
//                             <li>
//                                 Points can be redeemed after first-time purchases reach AED
//                                 5,000.
//                             </li>
//                             <li>Redemption is available through gifts catalog.</li>
//                         </ul>
//                     </div>
//                 </div>

//                 <div className="policy-card">
//                     <div className="policy-icon">
//                         <FaArrowDown />
//                     </div>

//                     <div className="policy-content">
//                         <h3>Downgrade Policy</h3>
//                         <p>
//                             Gold or Platinum members who fail to meet their target for 2
//                             consecutive months will be downgraded.
//                         </p>
//                     </div>
//                 </div>

//                 <div className="policy-card">
//                     <div className="policy-icon">
//                         <FaAward />
//                     </div>

//                     <div className="policy-content">
//                         <h3>Loyalty Milestone Bonus</h3>
//                         <p>
//                             Gold & Platinum members who achieve monthly targets for 6
//                             consecutive months receive bonus points and special rewards.
//                         </p>
//                     </div>
//                 </div>

//                 <div className="policy-card">
//                     <div className="policy-icon">
//                         <FaShieldAlt />
//                     </div>

//                     <div className="policy-content">
//                         <h3>General Conditions</h3>
//                         <ul>
//                             <li>Points are valid for 12 months.</li>
//                             <li>Points are non-transferable.</li>
//                             <li>Points cannot be exchanged for cash.</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RewardsPolicy;




// import React from 'react';

// const RewardsPolicy = () => {
//     const tiers = [
//         {
//             name: 'Silver',
//             monthlySpend: '1 – 10,000',
//             color: '🥈 Silver',
//             rewardPoints: '1,000 Points',
//             creditPeriod: 'Up to 30 Days',
//             welcomePoints: '500 Points',
//         },
//         {
//             name: 'Gold',
//             monthlySpend: '10,001 – 29,999',
//             color: '🥇 Gold',
//             rewardPoints: '1,500 Points',
//             creditPeriod: 'Up to 45 Days',
//             welcomePoints: '1,000 Points',
//             loyaltyBonus: '5,000 Points',
//             annualGift: 'Surprise Annual Gift',
//         },
//         {
//             name: 'Platinum',
//             monthlySpend: '30,000+',
//             color: '💎 Platinum',
//             rewardPoints: '2,000 Points',
//             creditPeriod: 'Up to 60 Days',
//             welcomePoints: '3,000 Points',
//             loyaltyBonus: '10,000 Points',
//             annualGift: 'Surprise Annual Gift',
//         },
//     ];

//     const styles = {
//         page: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '16px',
//             color: '#6f6f6f',
//             lineHeight: '1.7',
//             backgroundColor: '#fff',
//         },
//         mainTitle: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '22px',
//             fontWeight: 700,
//             color: '#000',
//             textAlign: 'center',
//             marginBottom: '28px',
//         },
//         sectionTitle: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '18px',
//             fontWeight: 700,
//             color: '#000',
//             lineHeight: '1.4',
//             marginTop: '22px',
//             marginBottom: '12px',
//         },
//         text: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '14px',
//             fontWeight: 400,
//             color: '#6f6f6f',
//             lineHeight: '1.7',
//             marginBottom: '12px',
//         },
//         listItem: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '14px',
//             fontWeight: 400,
//             color: '#6f6f6f',
//             lineHeight: '1.7',
//             marginBottom: '6px',
//         },
//         tableHeader: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '16px',
//             fontWeight: 700,
//             color: '#000',
//             backgroundColor: '#f8f8f8',
//         },
//         tableCell: {
//             fontFamily: 'Georgia, "Times New Roman", Times, serif',
//             fontSize: '16px',
//             fontWeight: 400,
//             color: '#6f6f6f',
//             lineHeight: '1.7',
//         },
//     };

//     return (
//         <div className="container py-4" style={styles.page}>
//             <h2 style={styles.mainTitle}>
//                 🌟 Customer Membership & Reward Policy 🌟
//             </h2>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>
//                     1. Membership Tiers (Monthly Spend Basis)
//                 </h3>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Monthly Spend (AED)</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.monthlySpend}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>
//                     2. Reward Points (Per AED 10,000 Spent)
//                 </h3>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Reward Points</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.rewardPoints}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>3. Credit Facility</h3>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Credit Period</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.creditPeriod}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>
//                     4. Welcoming Points (One-Time on Joining)
//                 </h3>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Welcoming Points</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.welcomePoints}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>5. Redemption Policy</h3>

//                 <ul>
//                     <li style={styles.listItem}>
//                         Points can be redeemed anytime after a member’s total first-time purchases reach AED 5,000, which may include multiple invoices.
//                     </li>

//                     <li style={styles.listItem}>
//                         Redemption is available via the listed products/gifts catalog.
//                     </li>
//                 </ul>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>6. Downgrade Policy</h3>

//                 <p style={styles.text}>
//                     If any member (Gold or Platinum) fails to meet their monthly target
//                     for two consecutive months, they will be automatically downgraded
//                     to the lower tier in the third month without prior notice.
//                 </p>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>7. Loyalty Milestone Bonus</h3>

//                 <p style={styles.text}>
//                     Gold & Platinum members only: Members who consistently achieve
//                     their monthly target for 6 consecutive months will receive:
//                 </p>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Bonus Points</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.slice(1).map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.loyaltyBonus}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 <p style={styles.text}>
//                     Annual / 9-Month Milestone: Members who consistently achieve
//                     their monthly target for 12 consecutive months or 9 months
//                     will receive:
//                 </p>

//                 <div className="table-responsive">
//                     <table className="table table-bordered">
//                         <thead>
//                             <tr>
//                                 <th style={styles.tableHeader}>Tier</th>
//                                 <th style={styles.tableHeader}>Special Gift</th>
//                                 <th style={styles.tableHeader}>Color</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {tiers.slice(1).map((tier) => (
//                                 <tr key={tier.name}>
//                                     <td style={styles.tableCell}>{tier.name}</td>
//                                     <td style={styles.tableCell}>{tier.annualGift}</td>
//                                     <td style={styles.tableCell}>{tier.color}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mb-4">
//                 <h3 style={styles.sectionTitle}>8. General Conditions</h3>

//                 <ul>
//                     <li style={styles.listItem}>
//                         Points are valid for 12 months from the date of earning.
//                     </li>

//                     <li style={styles.listItem}>
//                         Points are non-transferable and cannot be exchanged for cash.
//                     </li>

//                     <li style={styles.listItem}>
//                         The redemption catalog may be updated at any time without prior notice.
//                     </li>
//                 </ul>
//             </div>
//         </div>
//     );
// };

// export default RewardsPolicy;


import React from 'react';

const RewardsPolicy = () => {
    // const styles = {
    //     sectionTitle: {
    //         fontSize: '18px',
    //         fontWeight: 700,
    //         color: '#000',
    //         lineHeight: '1.4',
    //         marginTop: '22px',
    //         marginBottom: '12px',
    //     },
    //     text: {
    //         fontSize: '14px',
    //         color: '#6f6f6f',
    //         lineHeight: '1.7',
    //         marginBottom: '12px',
    //     },
    //     bulletList: {
    //         listStyleType: 'disc',
    //         paddingLeft: '25px',
    //         marginBottom: '15px',
    //     },
    //     listItem: {
    //         fontFamily: '"Open Sans", Arial, sans-serif',
    //         fontSize: '14px',
    //         color: '#6f6f6f',
    //         lineHeight: '1.8',
    //         marginBottom: '6px',
    //     },
    // };

    const styles = {
        sectionTitle: {
            fontFamily: 'Georgia, "Times New Roman", Times, serif',
            fontSize: '18px',
            fontWeight: 700,
            color: '#000',
            lineHeight: '1.4',
            marginTop: '22px',
            marginBottom: '12px',
        },

        text: {
            fontFamily: 'Georgia, "Times New Roman", Times, serif',
            fontSize: '14px',
            color: '#6f6f6f',
            lineHeight: '1.7',
            marginBottom: '12px',
        },

        bulletList: {
            listStyleType: 'disc',
            paddingLeft: '25px',
            marginBottom: '15px',
        },

        listItem: {
            fontFamily: 'Georgia, "Times New Roman", Times, serif',
            fontSize: '14px',
            color: '#6f6f6f',
            lineHeight: '1.7',
            marginBottom: '6px',
        },

        mainTitle: {
            fontFamily: 'Georgia, "Times New Roman", Times, serif',
            fontSize: '28px',
            fontWeight: 700,
            color: '#000',
            marginBottom: '20px',
        },
    };

    return (
        <div className="about-section">
            <div className="row justify-content-center">
                <div className="col-8">

                    <h2>
                        Customer Membership & Reward Policy
                    </h2>

                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>
                            1. Membership Tiers (Monthly Spend Basis)
                        </h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Silver</strong> - Monthly Spend 1 to 10,000 AED
                            </li>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - Monthly Spend 10,001 to 29,999 AED
                            </li>
                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - Monthly Spend 30,000+ AED
                            </li>
                        </ul>
                    </div>

                    {/* 2. Reward Points */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>
                            2. Reward Points (Per AED 10,000 Spent)
                        </h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Silver</strong> - 1,000 Points
                            </li>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - 1,500 Points
                            </li>
                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - 2,000 Points
                            </li>
                        </ul>
                    </div>

                    {/* 3. Credit Facility */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>3. Credit Facility</h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Silver</strong> - Up to 30 Days
                            </li>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - Up to 45 Days
                            </li>
                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - Up to 60 Days
                            </li>
                        </ul>
                    </div>

                    {/* 4. Welcoming Points */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>
                            4. Welcoming Points (One-Time on Joining)
                        </h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Silver</strong> - 500 Points
                            </li>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - 1,000 Points
                            </li>
                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - 3,000 Points
                            </li>
                        </ul>
                    </div>

                    {/* 5. Redemption Policy */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>5. Redemption Policy</h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                Points can be redeemed anytime after a member’s total
                                first-time purchases reach AED 10,000, which may include
                                multiple invoices.
                            </li>

                            <li style={styles.listItem}>
                                Redemption is available via the listed products/gifts
                                catalog.
                            </li>
                        </ul>
                    </div>

                    {/* 6. Downgrade Policy */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>6. Downgrade Policy</h3>

                        <p style={styles.text}>
                            If any member (Gold or Platinum) fails to meet their monthly
                            target for two consecutive months, they will be automatically
                            downgraded to the lower tier in the third month without prior
                            notice.
                        </p>
                    </div>

                    {/* 7. Loyalty Milestone Bonus */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>7. Loyalty Milestone Bonus</h3>

                        <p style={styles.text}>
                            Gold & Platinum members only: Members who consistently achieve
                            their monthly target for 6 consecutive months will receive:
                        </p>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - 5,000 Bonus Points
                            </li>

                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - 10,000 Bonus Points
                            </li>
                        </ul>

                        <p style={styles.text}>
                            Annual / 9-Month Milestone: Members who consistently achieve
                            their monthly target for 12 consecutive months or 9 months
                            will receive:
                        </p>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                <strong>Gold</strong> - Surprise Annual Gift
                            </li>

                            <li style={styles.listItem}>
                                <strong>Platinum</strong> - Surprise Annual Gift
                            </li>
                        </ul>
                    </div>

                    {/* 8. General Conditions */}
                    <div className="mb-4">
                        <h3 style={styles.sectionTitle}>8. General Conditions</h3>

                        <ul style={styles.bulletList}>
                            <li style={styles.listItem}>
                                Points are valid for 12 months from the date of earning.
                            </li>

                            <li style={styles.listItem}>
                                Points are non-transferable and cannot be exchanged for
                                cash.
                            </li>

                            <li style={styles.listItem}>
                                The redemption catalog may be updated at any time without
                                prior notice.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RewardsPolicy;